import { render, staticRenderFns } from "./ChooseTeacher.vue?vue&type=template&id=2ba97fa9&scoped=true"
import script from "./ChooseTeacher.vue?vue&type=script&lang=js"
export * from "./ChooseTeacher.vue?vue&type=script&lang=js"
import style0 from "./ChooseTeacher.vue?vue&type=style&index=0&id=2ba97fa9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba97fa9",
  null
  
)

export default component.exports